import script from "./costReport.vue?vue&type=script&setup=true&lang=js"
export * from "./costReport.vue?vue&type=script&setup=true&lang=js"

import "./costReport.vue?vue&type=style&index=0&id=37113055&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37113055"]])

export default __exports__